const debounce = (fn, wait) => {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
};

class FooterExpanded extends HTMLElement {
  constructor() {
    super();
    this.footer = this.querySelector("[data-footer]");
    this.page_type = window.theme.page_type;
  }

  connectedCallback() {
    if (this.page_type == "index") {
      document.body.classList.add("sticky-footer");
      this.setHeight();
    }

    this.onResize = debounce(this.setHeight.bind(this), 200);
    window.addEventListener("resize", this.onResize);
  }

  setHeight() {
    this.footerHeight = this.footer.offsetHeight;
    const mainEl = document.querySelector(".main-content-wrapper");
    mainEl.style.marginBottom = `${this.footerHeight}px`;
  }
}

if (!customElements.get("footer-expanded")) {
  customElements.define("footer-expanded", FooterExpanded);
}
